<template>
	<div id="plansoldier">
        <HrrBreadcrumb PMname="岗位计划管理" CMname="军转业岗位管理" />
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item label="计划">
                        <el-select v-model="searchform.planId" placeholder="请选择">
                            <el-option v-for="item in planIdData" :key="item.planId" :label="item.planName" :value="item.planId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="岗位名称">
                        <el-input v-model="searchform.post" placeholder="岗位名称"></el-input>
                    </el-form-item>
                    <el-form-item label="专业">
                        <el-input v-model="searchform.major" placeholder="专业"></el-input>
                    </el-form-item>
                    <el-form-item label="学历">
                        <el-select v-model="searchform.educationType" placeholder="请选择">
                            <el-option key="" label="全部" value=""></el-option>
                            <el-option v-for="item in educationTypeDta" :key="item.typeValue" :label="item.typeName" :value="item.typeName">
							</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学位">
                        <el-select v-model="searchform.diplomaType" placeholder="请选择">
                            <el-option key="" label="全部" value=""></el-option>
                            <el-option v-for="item in diplomaTypeData" :key="item.typeValue" :label="item.typeName" :value="item.typeName">
							</el-option>
                        </el-select>
                    </el-form-item>
                    <!--<el-form-item label="政治面貌">
                        <el-select v-model="searchform.politicalType" placeholder="请选择">
                            <el-option key="" label="全部" value=""></el-option>
                            <el-option v-for="item in politicalTypeData" :key="item.typeValue" :label="item.typeName" :value="item.typeValue">
							</el-option>
                        </el-select>
                    </el-form-item>-->
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick()">新增</el-button>
                    <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick()">编辑</el-button>
                    <el-button type="primary" icon="el-icon-delete" size="small" @click="delclick()">删除</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="tableData" @cell-click="cellclick" @selection-change="selectionchange"
                border
                stripe
                highlight-current-row
                style="width: 100%" v-loading="loading" >
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="post" label="岗位名称" width="150" fixed="left">
                    </el-table-column>
                    <el-table-column prop="postDesc" label="岗位简介" width="180">
                    </el-table-column>
                    <el-table-column prop="major" label="专业" width="180">
                    </el-table-column>
                    <el-table-column prop="educationType" label="学历要求" width="100">
                    </el-table-column>
                    <el-table-column prop="diplomaType" label="学位要求" width="100">
                    </el-table-column>
                    <el-table-column prop="politicalType" label="政治面貌" width="100">
                    </el-table-column>
                    <el-table-column prop="other" label="其他条件" width="180">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" >
                    </el-table-column>
                    <el-table-column label="操作" width="120" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="Rowview(scope.row)" type="text" size="small">查看</el-button>
                            <el-button @click.stop="RowEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click.stop="Rowdelete(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
	</div>
</template>
<script>
    export default {
        name: 'plan_soldier',
        data() {
            return {
                searchform: {
                    pageNum: 1,
                    pageSize: 10,
                    planId:"",
                    post: "",
                    major:"",
                    educationType:"",
                    diplomaType:"",
                    politicalType:""
                },
                tableData: [],
                total: 0,
                loading: true,
                selectionRows:[],
                planform: {
                    planId: ""
                },
                planIdData: [],
                educationTypeDta:[],
                diplomaTypeData:[],
                politicalTypeData:[]
            }
        },
        methods: {
            onSubmit() {             
                this.initData();
            },
            handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.initData();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.initData();
			},
            Rowview(val) {
                const postid = val.postId;
                this.$route.meta.row = val;
                this.$router.push({
                    path: '/plan/soldier/view/' + postid
                });
            },
            RowEdit(val) {
                const postid = val.postId;
                this.$route.meta.row = val;
                this.$router.push({
                    path: '/plan/soldier/modify/' + postid
                });
            },
            Rowdelete(val){
				this.$confirm("确定要删除 '"+val.post+"' 此记录么？","删除提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios.post(this.$api.plan.soldierDel,{soldierId:val.soldierId})
					.then((response)=>{
						var redata=response.data;
						if(redata.success==true){
							Vuethis.$message({message:"删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
            Addclick() {
                this.$router.push({
                    path: '/plan/soldier/add',
                });
            },
            editclick(){
				if(this.selectionRows.length==0)
				{
					this.$message.warning("请先选择一行记录");
					return;
				}
				if(this.selectionRows.length>1)
				{
					this.$message.warning("只能操作一行记录");
					return;
				}
				this.$route.meta.row=this.selectionRows[0];
				this.$router.push({path:'/plan/soldier/edit/'+this.selectionRows[0].soldierId});
			},
            delclick(){
				if(this.selectionRows.length<1)
				{
					this.$message.warning("请先选择一行记录");
					return;
				}
				this.$confirm("确定要删除选中的功能？","删除提示",{type:"warning"}).then(()=>{
					var Vuethis=this;
					this.selectionRows.forEach(row=>{
						this.$hrraxios.post(this.$api.plan.soldierDel,{soldierId:row.soldierId})
						.then((response)=>{
							Vuethis.loading = false;
                            var data = response.data;
                            // console.log(data)
                            if (data.success == true) {
                                Vuethis.$message.success("已删除");
                                this.initData();
                            } else {
                                Vuethis.$message.error(data.prompt);
                            }
						})
						.catch((error)=>{
                            console.log(error);
						})
					});
				}).catch(()=>{

				});
			},
			cellclick(row, column, cell, event){
				this.$refs.tableData.toggleRowSelection(row);
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
            initData() {
                var Vuethis = this;
                this.loading = true;
                this.$hrraxios.get(this.$api.plan.soldierList, {
                    params: this.searchform
                })
                .then(function(response) {
                    Vuethis.loading = false;
					var data = response.data;
					// console.log(response)
                    if (data.success == true) {
						Vuethis.tableData = data.data.list;
						Vuethis.total=data.data.total;
                        // Vuethis.planform.planId = data.data[0].planId;
                    } else {
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
            },
            initParamsData(){
                this.$common.getplanlist(this,"planIdData");
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"Education_Type"},"educationTypeDta",this);
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"Diploma_Type"},"diplomaTypeData",this);
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"Political_Type"},"politicalTypeData",this);
            }     
        },
        beforeRouteLeave(to, from, next) {
            // 导航离开该组件的对应路由时调用
            to.meta.row = from.meta.row;
            next();
        },
        created() {
            this.initData();
            this.initParamsData();
        }   
    }
</script>
